export default {
  colors: {
    red: '#c33e2a',
    border: '#f3f5f7',
  }
}
